import React, { useState } from 'react';
import { Form } from 'react-final-form';
import { availableLoginMethodsByCountry } from '@containers/LoginContainer/Components/tabs/availableLogonMethods.service';
import { MobileID, Biometrics, SmartID, EIDeasy } from '@containers/Auth/methods';
import LoginMethodsList from '@containers/LoginContainer/Components/loginMethodsList/loginMethodsList';
import { LoginMethodsOptionContainer } from '@containers/LoginContainer/Components/loginMethodsList/loginMethodsList.styles';
import {
  AuthenticationHeaderContainer,
  LinkButtonModified,
  ToastStyles
} from '@containers/LoginContainer/styles/login.styles';
import { FormSubheading } from '@containers/Auth/components/countryForm/countryForm.styles';
import { useTranslation } from 'react-i18next';
import Icons from '@single-platform/components/dist/assets/icons';
import { Toast } from '@components/Toast/Toast';
import { useDispatch, useSelector } from 'react-redux';
import { AuthActions } from '@redux';

export const LoginForm = React.memo(
  ({ onSubmit, isSubmitting, personalData, setSubmitStatus, setStep, step }) => {
    const availableLoginMethods = availableLoginMethodsByCountry(personalData.country);
    const [activeTab, setActiveTab] = useState('');
    const [currentStep, setCurrentStep] = useState('');
    const { t } = useTranslation();
    const isLoginError = useSelector((state) => state.AuthReducers.notificationError);
    const dispatch = useDispatch();

    const switchTabHandler = (value) => {
      setActiveTab(value);
      setStep(value);
      setCurrentStep('personalForm');
    };

    const renderSwitch = (param) => {
      switch (param) {
        case 'Mobile-ID':
          return (
            <MobileID
              setSubmitStatus={setSubmitStatus}
              personalData={personalData}
              setCurrentStep={setCurrentStep}
            />
          );
        case 'Biometrics':
          return (
            <Biometrics
              setSubmitStatus={setSubmitStatus}
              personalData={personalData}
              setCurrentStep={setCurrentStep}
            />
          );
        case 'eideasy':
        case 'IDIN':
        case 'FTN':
        case 'eParakts':
          return (
            <EIDeasy
              personalData={personalData}
              setCurrentStep={setCurrentStep}
              setSubmitStatus={setSubmitStatus}
              setActiveTab={setActiveTab}
              setStep={setStep}
              step={step}
            />
          );
        default:
          return (
            <SmartID
              setSubmitStatus={setSubmitStatus}
              personalData={personalData}
              setCurrentStep={setCurrentStep}
            />
          );
      }
    };

    const onBack = async () => {
      setCurrentStep('countrySelect');
      setStep('personalInfo');
      setActiveTab(null);
      dispatch(AuthActions.clearNotificationError());
      setSubmitStatus({
        isSubmitting: false,
        type: null
      });
    };

    return (
      <>
        {step === 'eideasy' && (
          <LoginMethodsOptionContainer>{renderSwitch(step)}</LoginMethodsOptionContainer>
        )}
        <Form
          onSubmit={(values) => onSubmit(values)}
          render={() => {
            return (
              <>
                {!isSubmitting && !activeTab && (
                  <LoginMethodsList
                    loginTypes={availableLoginMethods}
                    onSwitch={switchTabHandler}
                  />
                )}
                {activeTab && (
                  <>
                    <AuthenticationHeaderContainer>
                      {currentStep !== 'countrySelect' && !isSubmitting && (
                        <FormSubheading>
                          <LinkButtonModified onClick={onBack}>
                            <Icons.ArrowLeft />
                            {t('back')}
                          </LinkButtonModified>
                        </FormSubheading>
                      )}
                    </AuthenticationHeaderContainer>
                    <LoginMethodsOptionContainer>
                      {renderSwitch(activeTab)}
                    </LoginMethodsOptionContainer>
                    <ToastStyles>
                      <Toast
                        isVisible={isLoginError}
                        variant="error"
                        i18nKey="login_validation_error"
                        components={[
                          <strong key="bold" />,
                          <br />,
                          <span key="text" />,
                          <a key="link" href="/?step=intro" rel="noopener noreferrer" />
                        ]}
                      />
                    </ToastStyles>
                  </>
                )}
              </>
            );
          }}
        />
      </>
    );
  }
);
